import { styled as o } from "styled-components";
import { Theme as r } from "../../../../styles/themes/index.js";
const n = o.button`
  display: flex;
  align-items: center;
  color: rgb(${r.colors.Alpha});
  background: transparent;
  border: none;
`;
export {
  n as Container
};
